module.exports = __webpack_public_path__ + "img/main4.3aad5e40.png";